<template>
  <div>
    <div class="lan-dong">
      <span class="text-gray-style">证书</span>
      <div style="margin-top: 24px">
        <CDNRadios
          v-model="UserAgentAction"
          :items="items1"
          label="申请类型"
          :hasLine="false"
        />
      </div>
    </div>
    <div class="" v-if="UserAgentAction === 0">
      <div class="lan-dong">
        <span class="text-gray-style">证书内容</span>

        <div style="margin-top: 24px">
          <el-input type="textarea" :rows="5" v-model="certContent"> </el-input>
          <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
            只支持pem格式
          </div>
        </div>
      </div>

      <div class="lan-dong">
        <span class="text-gray-style">私钥内容</span>
        <div style="margin-top: 24px">
          <el-input type="textarea" :rows="5" v-model="syContent"> </el-input>
          <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
            只支持pem格式
          </div>
        </div>
      </div>
      <div class="text-class">申请类型：手动上传</div>
      <div class="text-class">到期时间：1970-01-01 08:00:00</div>
    </div>
    <div v-if="UserAgentAction === 1">
      <div class="text-class">CNAME解析: 解析内容</div>
      <CDNCheckbox
        @selectedCheck="(e) => (matchUserAgnet1 = e)"
        :front="false"
        :checkedStatus="matchUserAgnet1"
        :label="'自动续期'"
      />
    </div>
    <div class="btn-commit" @click="commit">
      {{ $t("product.commit") }}
    </div>

    <div class="my-line"></div>
    <!-- ~~~~~~~ -->
    <div class="lan-dong margin-top">
      <CDNSwitch
        :label="'Hsts'"
        tipLabel="强制使用https与服务器创建连接"
        :hasbottomline="false"
        @change="HstsChange"
      />
    </div>

    <div class="my-line"></div>

    <div class="lan-dong margin-top">
      <CDNSwitch
        :label="'强制跳转'"
        :hasbottomline="false"
        @change="forceChange"
      />
    </div>
    <div class="my-line"></div>

    <div class="lan-dong margin-top">
      <CDNSwitch
        :label="'旧网站兼容'"
        :hasbottomline="false"
        tipLabel="开启会影响HTTP跳转"
        @change="oldSiteChange"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { uploadCert, applyCert, configCN } from "@/service/requestRes";
export default {
  props: {
    domainHost: String,
  },
  data() {
    return {
      UserAgentAction: 0,
      certContent: "",
      syContent: "",
      matchUserAgnet1: "",
    };
  },
  computed: {
    items1() {
      return [
        {
          label: "手动上传",
          value: 0,
        },
        {
          label: "DNS自动签发证书",
          value: 1,
        },
      ];
    },
  },
  methods: {
    uploadMycert({ ssl_cert, ssl_key }) {
      uploadCert({ ssl_cert, ssl_key, host: this.domainHost }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: "上传成功",
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    applyMyCert() {
      applyCert(this.domainHost).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: "申请成功",
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    configCNMethod(obj) {
      configCN({
        ...obj,
        host: this.domainHost,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    commit() {
      if (!this.UserAgentAction) {
        if (!this.certContent) {
          this.$message({
            message: "请输入证书内容",
            type: "success",
          });
          return;
        }
        if (!this.syContent) {
          this.$message({
            message: "请输入证书秘钥",
            type: "success",
          });
          return;
        }
        this.uploadMycert({
          ssl_cert: this.certContent,
          ssl_key: this.syContent,
        });
      } else {
        this.applyMyCert();
      }
    },
    HstsChange(e) {
      const lockHSTS = { func: "lockHSTS", host: this.domainHost, lockHSTS: e };
      this.configCNMethod(lockHSTS);
    },
    forceChange(e) {
      const lockHttps = {
        func: "lockHttps",
        host: this.domainHost,
        lockHttps: e,
      };

      this.configCNMethod(lockHttps);
    },
    oldSiteChange(e) {
      const openCSPCheat = {
        func: "openCSPCheat",
        host: this.domainHost,
        openCSPCheat: e,
      };

      this.configCNMethod(openCSPCheat);
    },
  },
};
</script>

<style lang="scss" scoped>
.cenue-title {
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #131523;
}

.lan-dong {
  margin-top: 28px;
  .checkbox-content {
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
}

.margin-top {
  margin-top: -15px;
}

.btn-commit {
  padding: 8px 44px;
  margin: 24px 24px;
  width: 120px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
}
.row-line {
  display: flex;
  align-items: flex-end;
  margin-bottom: 36px;
  .new-add {
    padding: 8px 44px;
    width: 120px;
    height: 40px;
    background: #d9e4ff;
    border-radius: 4px;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #1e5eff;
    cursor: pointer;
    margin-left: 10px;
    margin-bottom: 6px;
  }
}

.lan-dong-link {
  display: flex;
  margin-top: 24px;
}
.handle-first {
  cursor: pointer;
}
.cenum-setting {
  padding: 21px 0;
}
.my-line {
  width: 100%;
  height: 3px;
  background-color: #1e5eff;
  margin: 48px 0 24px 0;
}
.text-class {
  font-size: 14px;
  color: #666666;
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>
